import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	data: [],
	isLoaded: false,
	isError: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ******************* Fetch tv categories *******************
			case types.FETCH_TV_CATEGORY_LOADING:
				return { ...INITIAL_STATE };

			case types.FETCH_TV_CATEGORY_SUCCESS:
				draft.isLoaded = true;
				draft.data = action.payload;
				return;

			case types.FETCH_TV_CATEGORY_ERROR:
				draft.isError = true;
				return;

			default:
				return state;
		}
	});
